import * as React from "react";
import * as DocumentReader from "../DocumentReader";
import { Strings } from "../Stores/StringsStore";

interface ITypeAheadProps {
	searchResult: DocumentReader.TypeAheadSuggestion[];
	handleMouseDown: (event: React.MouseEvent<HTMLLIElement>) => void;
	selectedIndex: number;
	showNoResultsMessage: boolean;
}

export class TypeAhead extends React.PureComponent<ITypeAheadProps, {}> {

	render() {
		return this.props.searchResult.length > 0
			? <div className="typeahead">
				<ul>
					{
						this.props.searchResult.map((suggestion, index) => {
							return <TypeAheadItem selected={this.props.selectedIndex === index} key={suggestion.value} suggestion={suggestion} handleMouseDown={this.props.handleMouseDown} />;
						})
					}
				</ul>
			</div>
			: this.props.showNoResultsMessage ? <div className="typeahead">{Strings.reader.typeAheadNoResults}</div> : null;
	}
}

interface ITypeAheadItemProps {
	suggestion: DocumentReader.TypeAheadSuggestion;
	handleMouseDown: (event: React.MouseEvent<HTMLLIElement>) => void;
	selected: boolean;
}


class TypeAheadItem extends React.PureComponent<ITypeAheadItemProps, {}> {
	render() {
		let className = this.props.selected ? "selected" : "";
		return <li className={className} onMouseDown={this.props.handleMouseDown} data-value={this.props.suggestion.value}>
			<span className="prefix">{this.props.suggestion.prefix}</span>
			<span className="suffix">{this.props.suggestion.suffix}</span>
			<span className="count">({this.props.suggestion.count})</span>
		</li>;
	}
}
